import './index.scss'

import React from 'react'

import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
//import { Flex, Icon, Switch, Text } from '@ui-pc'
import Rate from '@ui-pc/RateStars'
import Switch from '@ui-pc/Switch'
import Text from '@ui-pc/Text'
import { Type } from '@utils/tool'

type Props = {
  num: string
  people?: string
  className?: string
  readonly?: boolean
  size?: number
  span?
}

function Index(props: Props) {
  const { num, people, className, span, size, readonly } = props
  const peopleNum = Type.number(people)
  // const number = Type.number(num)
  // console.log(number, 'number')

  return (
    <Switch either={Type.number(num) > 0}>
      <Flex
        span={span}
        cursor
        aria-label="review-snapshot"
        alignItems="center"
        className={className}>
        <Rate
          style={{ fontSize: size }}
          className="rate-snapshot-rate"
          value={Type.number(num)}
        />
        {/* <span className="rate-snapshot-num">{num}</span> */}
        <Switch either={!Type.isNever(people) && !readonly}>
          <Flex span="auto" alignItems="center" className="rate-snapshot-label">
            <Text className="rate-snapshot-label-text" underline>
              {peopleNum} {'Reviews'}
            </Text>
            {/* <Icon
              alt="rate"
              customSrc="icon-CaretRight"
              className="rate-snapshot-icon"
            /> */}
          </Flex>
        </Switch>
      </Flex>
      <Switch either={!readonly}>
        <Flex
          aria-label="Write a review"
          alignItems="center"
          className={`ind-widget-empty-rate ${className}`}>
          <Rate className="rate-snapshot-rate" value={Type.number(num)} />
          <Text gap={[0, 0]} underline className="rate-snapshot-label">
            {'Write a review'}
          </Text>
        </Flex>
      </Switch>
    </Switch>
  )
}

export default Index
